import { FunctionComponent } from 'react';
import styles from "./PageNotFound.module.css";
import { useNavigate } from 'react-router';
import SidebarLayout from '../../../component/common/Layout/SidebarLayout/SidebarLayout';
import CustomButton, { ButtonRadiusSize } from '../../../component/common/CustomButton/CustomButton';
import { PageRoutes } from '../../../routing/paths';

const Error404Page: FunctionComponent = () => {
    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate(PageRoutes.DASHBOARD);
    };

    const ErrorContent = (
        <div className={styles.error404page}>
            <div className={styles.errorCard}>
                <img src='./images/error404.png' alt='Error 404' />
                <h1>Page not found</h1>
                <p>
                    Looks like this page swam away! <br />
                    The page you're looking for doesn't exist or has been moved.
                </p>
                <CustomButton
                    onClick={handleButtonClick}
                    btnRadius={ButtonRadiusSize.SMALL}
                    className={styles.errorbtn}
                >
                    Back to Dashboard
                </CustomButton>
            </div>
        </div>
    );

    return (
        <SidebarLayout className={styles.errorPageLay}>
            {ErrorContent}
        </SidebarLayout>
    );
};

export default Error404Page;
